import React, { useEffect } from "react";
import UserDashboardPage from "./components/UserDashboardPage";
import { useAppDispatch, useAppSelector } from "../../hooks/redux-hooks";
import { getUser } from "../../slices/authSlice";

const DashboardPage: React.FC = () => {

  const dispatch = useAppDispatch();

  const basicUserInfo = useAppSelector((state) => state.auth.basicUserInfo);

  useEffect(() => {
    if (basicUserInfo) {
      dispatch(getUser(basicUserInfo.id));
    }
  }, [basicUserInfo]);

  return (
    <>
     <UserDashboardPage />
    </>
  );
};


export default DashboardPage;
